import React from "react";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>המידע המבוקש לא נמצא</h1>
      <h1>404</h1>
      <h2>שים לב שהקלדת את הURL כמו שצריך</h2>
      <p>למה זה קרה? יתכן והקישור שלך אינו תקין או מלא!</p>
      <p>הקפד להקליד את ה URL שלך בצורה מלאה ותקינה! </p>
      <p>המשך יום טוב</p>
    </div>
  );
};

export default NotFound;
